import { map } from 'ramda';
import React, { FunctionComponent, useState } from 'react';
import { connect } from 'react-redux';
import { ProspectStatus } from '../../common/enums/ProspectStatus';
import { IBindingCallback1 } from '../../common/models/callback';
import { IUpdateOwner } from '../../common/models/candidate/IUpdateOwner';
import { IProspect } from '../../common/models/prospect/IProspect';
import { IProspectStatus } from '../../common/models/prospect/IProspectStatus';
import Icon from '../../components/Icon';
import RegularButton from '../../components/RegularButton';
import ChangeOwner from '../ChangeOwner';
import { updateProspectsOwnerRoutine } from './routines';

interface IProps {
  selected: IProspect[];
  filter: ProspectStatus;
  changeStatus: IBindingCallback1<IProspectStatus>;
  updateProspectsOwner: IBindingCallback1<IUpdateOwner>;
}

const ProspectsBulkActions: FunctionComponent<IProps> = ({ selected, filter, changeStatus, updateProspectsOwner }) => {
  const [isReassign, setIsReassign] = useState(false);
  const isArchive = filter === ProspectStatus.Active;
  const ids = map(prospect => prospect.contactId, selected);

  const onArchive = () => {
    changeStatus({
      ids,
      status: isArchive ? ProspectStatus.Archived : ProspectStatus.Active
    });
  };

  return (
    <div className="bulk-actions">
      <RegularButton
        icon={<Icon icon="userChange" />}
        variant="tertiary"
        textIntlId="iconButtonLable.reassign"
        defaultMessage="Reassign"
        onClick={() => setIsReassign(true)}
      />
      <ChangeOwner
        isShown={isReassign}
        onHide={() => setIsReassign(false)}
        ids={ids}
        variant="prospects"
        updateOwner={updateProspectsOwner}
      />
      <RegularButton
        icon={<Icon icon={isArchive ? 'archive' : 'unarchive'} />}
        variant="tertiary"
        textIntlId={isArchive ? 'iconButtonLable.arhive' : 'iconButtonLable.unarhive'}
        defaultMessage={isArchive ? 'Archive' : 'Unarchive'}
        onClick={onArchive}
      />
    </div>
  );
};

const mapDispachToProps = {
  updateProspectsOwner: updateProspectsOwnerRoutine
};

export default connect(null, mapDispachToProps)(ProspectsBulkActions);
